type DividerProps = {
  className?: string;
};

export function Divider({ className }: DividerProps) {
  return (
    <div className={className}>
      <hr className="border-b-1 border-neutral-30" />
    </div>
  );
}
